// extracted by mini-css-extract-plugin
export default {"partners__card":"PartnerCard_partners__card__-xZ3L","partners__imgBx":"PartnerCard_partners__imgBx__IFcKg","partner__without_img":"PartnerCard_partner__without_img__PQJg4"};